import { render, staticRenderFns } from "./AgronomySampleDetail.vue?vue&type=template&id=e4955aa2"
import script from "./AgronomySampleDetail.vue?vue&type=script&lang=js"
export * from "./AgronomySampleDetail.vue?vue&type=script&lang=js"
import style0 from "./AgronomySampleDetail.vue?vue&type=style&index=0&id=e4955aa2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports